<template>
  <div class="main-row">
    <div class="left-column">
      <div class="infobox">
        <h4>Steg 1 av 2</h4>
        <p>Først trenger vi litt informasjon om deg.<br>
        Vennligst fyll ut feltene i skjemaet.<br>
        Du vil få mulighet til å teste ulike valg senere.</p>
      </div>
    </div>
    <div class="right-column">
      <v-form v-model="valid" class="form">
        <span class="years-in-it">
          <v-select
              attach=".years-in-it"
              v-model="user.years_in_it"
              :items="field_options_years"
              :rules="rules.required"
              placeholder="Antall år i relevant arbeid"
              prepend-icon="timeline"
              required
          ></v-select>
        </span>
        <v-text-field
          v-model="user.salary"
          :rules="rules.salary"
          label="Din årslønn, inkludert bonus og overtid"
          hint="F.eks 500000"
          required
          type="number"
          prepend-icon="local_atm"
        ></v-text-field>
        <v-text-field
          v-model="user.work_percentage"
          :rules="rules.work_percentage"
          type="number"
          required
          label="Stillingsbrøk i prosent"
          prepend-icon="pie_chart"
          hint="Hvis du jobber fulltid skal denne være 100"
        ></v-text-field>
        <br><v-btn :disabled="!valid" to="/form-final" block color="primary">gå videre<v-icon>navigate_next</v-icon></v-btn>
      </v-form>

    </div>
  </div>
</template>

<script>
  export default {
    props: { 
      user: Object 
    },
    data: () => ({
      valid: true,
      rules: {
        salary: [
          val => !!val || 'Denne må fylles ut',
          val => val < 10000000 || 'Fyll inn din virkelige lønn i hele tall'
        ],
        work_percentage: [
          val => !!val || 'Denne må fylles ut',
          val => val < 200 || 'Jobber du virkelig så mye?'
        ],
        required: [ 
          val => !!val || 'Denne må fylles ut' 
        ]
      },
      field_options_years: [
        '0-4 år',
        '5-9 år',
        '10-14 år',
        '15-19 år',
        '20-24 år',
        '25-29 år',
        '30+ år',
      ]
    })
  }
</script>

<style lang="scss">
  .digi-kalk {
  //fix to make the dropdown position work when app is embedded
  .v-menu__content {
    top: auto !important;
    left: auto !important;
    margin-left: 33px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Form.vue